import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import BedbankMultiRoomBuySection from '../MultiRoom/BedbankMultiRoomBuySection'
import BedbankMultiRoomNoDatesCTA from '../MultiRoom/BedbankMultiRoomNoDatesCTA'
import { selectLoggedIn } from 'selectors/accountSelectors'
import BedbankMultiRoomLoginCTA from '../MultiRoom/BedbankMultiRoomLoginCTA'

interface Props {
  checkInDate?: string
  checkOutDate?: string
  isLoggedIn: boolean
}

function BedbankMultiIndividualRoomsFooter(props: Props) {
  const {
    checkInDate,
    checkOutDate,
    isLoggedIn,
  } = props

  const validCheckinCheckoutDates = !!(checkInDate && checkOutDate)

  if (!isLoggedIn) {
    return <BedbankMultiRoomLoginCTA />
  } else if (!validCheckinCheckoutDates) {
    return <BedbankMultiRoomNoDatesCTA />
  } else {
    return <BedbankMultiRoomBuySection />
  }
}

export default withOfferPageAndReduxState((state, appState): Props => {
  return {
    checkInDate: state.checkInDate,
    checkOutDate: state.checkOutDate,
    isLoggedIn: selectLoggedIn(appState),
  }
}, BedbankMultiIndividualRoomsFooter)
